import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider as MUIThemeProvider } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import { getTheme } from '@totalsoft/rocket-ui';
import { camelize } from 'utils/functions';
import { gql, useQuery } from '@apollo/client';
const { REACT_APP_DEFAULT_THEME } = process.env;

const APPLICATION_THEME_QUERY = gql`
  query applicationTheme {
    applicationTheme {
      themeName
    }
  }
`;

const ThemeProvider = ({ children }) => {
  const { data } = useQuery(APPLICATION_THEME_QUERY, {
    onError: err => console.warn(`Application theme could not be loaded! ${err}`)
  });

  const theme = useMemo(() => camelize(data?.applicationTheme?.themeName || REACT_APP_DEFAULT_THEME), [data]);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={getTheme({ globals: { theme } })}>{children}</MUIThemeProvider>
    </StyledEngineProvider>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.node
};

export default ThemeProvider;
